import React from 'react';
import MypageBasketArtistContainer from 'containers/MypageBasketArtistContainer';

export default function MypageBasketArtistPage() {
  return <MypageBasketArtistContainer />;
}
